import "./style.css";
import layout from "./layout.html";

export default class Hamburger {
  static selector = ".hamburger";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }
}
